import { createListReducer } from '../../../common/services/reducerCreator';

export default createListReducer('TOURNAMENT_AWARDS');
